// src/pages/EventPage.js
import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import EventDetails from '../components/EventDetails';
import SelfiePickerModal from '../components/modals/SelfiePickerModal';
import LoadingModal from '../components/modals/LoadingModal';
import axios from 'axios';
import config from '../config/config';

const EventPage = () => {
  const { id } = useParams();
  const { currentUser, isAuthenticated } = useAuth();
  const [event, setEvent] = useState(null);
  const [loading, setLoading] = useState(true);
  const [showSelfieModal, setShowSelfieModal] = useState(false);

  useEffect(() => {
    const fetchEvent = async () => {
      setLoading(true);
      try {
        const response = await axios.get(`${config.BASE_URL}/api/events/${id}`);
        
        
        // Check for missing fields and log warnings
        if (!response.data.event_description) {
          console.warn("⚠️ Event description is missing in API response");
        }
        
        if (!response.data.event_date) {
          console.warn("⚠️ Event date is missing in API response");
        }
        
        setEvent(response.data);
      } catch (err) {
        console.error("Error fetching event:", err);
        setEvent(null);
      } finally {
        setLoading(false);
      }
    };
    fetchEvent();
  }, [id]);

  // Add this to debug the structure
  useEffect(() => {
    
  }, [currentUser]);

  if (loading) {
    return <LoadingModal show={true} message="Loading event..." />;
  }

  if (!event) {
    return <div className="alert alert-danger">Event not found.</div>;
  }
  return (
    <div className="event-page">
      <EventDetails 
        event={event}
        onCheckIn={() => setShowSelfieModal(true)}
      />

      {/* Check if user exists and access it correctly based on structure */}
      {currentUser && (
        <SelfiePickerModal
          show={showSelfieModal}
          onClose={() => setShowSelfieModal(false)}
          eventId={String(event.id)}
          // Adjust this based on your actual user structure
          user={{
            id: String(currentUser.id || currentUser.user?.id || '0'), 
            user_type: currentUser.user_type || currentUser.user?.user_type || 'event_attendee'
          }}
        />
      )}

      {!isAuthenticated && (
        <div className="alert alert-warning">
          You need to be logged in to check-in with a selfie.
        </div>
      )}
    </div>
  );
};

export default EventPage;
